import { render, staticRenderFns } from "./ChbTextArea.vue?vue&type=template&id=62a508dc"
import script from "./ChbTextArea.vue?vue&type=script&lang=js"
export * from "./ChbTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports